/* Projektsalg ("Kælderen"): ambient video and the gallery lightbox. Progressive: without this file the
 * videos still play muted with their poster, and gallery links open the full image. */
(() => {
  if (window.__sgp) return; window.__sgp = true;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  let reduce = motion.matches;

  // Ambient video: no autoplay attribute in the markup. A clip plays only while on screen, never with
  // reduced motion (checked live), and the visitor can always pause it (WCAG 2.2.2). The toggle follows the
  // video's real state through its play and pause events, so a refused play() leaves it on "Afspil".
  const sync = v => {
    const b = v.parentElement.querySelector('[data-sgp-toggle]'); if (!b) return;
    b.setAttribute('aria-pressed', v.paused ? 'true' : 'false');
    b.setAttribute('aria-label', v.paused ? 'Afspil video' : 'Sæt video på pause');
  };
  // A clip the visitor started by hand plays even with reduced motion; the others still wait.
  const want = v => (v.dataset.sgpForce === '1' || !reduce) && v.dataset.sgpPaused !== '1' && v.dataset.sgpVisible === '1';
  const apply = v => { if (want(v)) v.play().catch(() => sync(v)); else v.pause(); };
  const io = new IntersectionObserver(es => es.forEach(e => {
    e.target.dataset.sgpVisible = e.isIntersecting ? '1' : '0'; apply(e.target);
  }), { threshold: .15 });
  const init = root => root.querySelectorAll('.sgp video').forEach(v => {
    if (v.__sgp) return; v.__sgp = true; v.muted = true;
    v.addEventListener('play', () => sync(v)); v.addEventListener('pause', () => sync(v));
    sync(v); io.observe(v);
  });
  init(document);
  motion.addEventListener('change', e => { reduce = e.matches; document.querySelectorAll('.sgp video').forEach(apply); });
  // Theme editor: a section re-rendered after a setting change brings new video elements.
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('.sgp video').forEach(v => io.unobserve(v)));
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-sgp-toggle]'); if (!b) return;
    const v = b.parentElement.querySelector('video'); if (!v) return;
    if (v.paused) { v.dataset.sgpPaused = '0'; v.dataset.sgpForce = '1'; v.play().catch(() => sync(v)); }
    else { v.dataset.sgpPaused = '1'; v.pause(); }
  });

  // Lightbox: one dialog per gallery, built on first use.
  const open = (gal, i) => {
    const items = [...gal.querySelectorAll('[data-sgp-lb]')];
    let dlg = gal.querySelector('.sgp-lb');
    if (!dlg) {
      dlg = document.createElement('dialog'); dlg.className = 'sgp-lb'; dlg.setAttribute('aria-label', 'Billedgalleri');
      dlg.innerHTML = '<figure class="sgp-lb-fig"><div class="sgp-lb-m"></div><figcaption class="sgp-lb-cap"></figcaption></figure>'
        + '<button type="button" class="sgp-lb-close" aria-label="Luk">&#10005;</button>'
        + '<button type="button" class="sgp-lb-prev" aria-label="Forrige billede">&#8592;</button>'
        + '<button type="button" class="sgp-lb-next" aria-label="Næste billede">&#8594;</button>';
      gal.appendChild(dlg);
      dlg.querySelector('.sgp-lb-close').onclick = () => dlg.close();
      dlg.querySelector('.sgp-lb-prev').onclick = () => show(dlg.__i - 1);
      dlg.querySelector('.sgp-lb-next').onclick = () => show(dlg.__i + 1);
      dlg.addEventListener('keydown', e => { if (e.key === 'ArrowLeft') show(dlg.__i - 1); if (e.key === 'ArrowRight') show(dlg.__i + 1); });
      dlg.addEventListener('click', e => { if (e.target === dlg) dlg.close(); });
      dlg.addEventListener('close', () => { dlg.querySelector('.sgp-lb-m').innerHTML = ''; items[dlg.__i] && items[dlg.__i].focus(); });
    }
    const show = n => {
      dlg.__i = (n + items.length) % items.length;
      const a = items[dlg.__i], m = dlg.querySelector('.sgp-lb-m');
      if (a.dataset.sgpVideo) {
        m.innerHTML = '<video muted loop playsinline autoplay controls></video>';
        m.firstChild.src = a.dataset.sgpVideo; if (motion.matches) m.firstChild.removeAttribute('autoplay');
      } else {
        // Reuse the tile's srcset so the browser fetches a size that fits the screen, not the 2400px original.
        const t = a.querySelector('img'); m.innerHTML = '<img alt="">'; const img = m.firstChild;
        if (t && t.srcset) { img.srcset = t.srcset; img.sizes = '(min-width: 750px) 90vw, 100vw'; }
        img.src = a.href; img.alt = a.dataset.sgpAlt || '';
      }
      const cap = dlg.querySelector('.sgp-lb-cap'); cap.textContent = a.dataset.sgpCap || '';
      if (gal.dataset.sgpAi) { const n = document.createElement('span'); n.className = 'sgp-lb-ai'; n.textContent = gal.dataset.sgpAi; cap.appendChild(n); }
    };
    show(i); dlg.showModal();
  };
  document.addEventListener('click', e => {
    const a = e.target.closest('[data-sgp-lb]'); if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    const gal = a.closest('.sgp-gallery'); if (!gal || !window.HTMLDialogElement) return;
    e.preventDefault(); open(gal, [...gal.querySelectorAll('[data-sgp-lb]')].indexOf(a));
  });
})();
